import { render, staticRenderFns } from "./IndicatorForTestingEvaluation.vue?vue&type=template&id=2c3df8d6&"
import script from "./IndicatorForTestingEvaluation.vue?vue&type=script&lang=js&"
export * from "./IndicatorForTestingEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports